export enum ModuleName {
	BasisTextureLoader = 'BasisTextureLoader',
	DRACOLoader = 'DRACOLoader',
	EXRLoader = 'EXRLoader',
	FBXLoader = 'FBXLoader',
	GLTFLoader = 'GLTFLoader',
	OBJLoader = 'OBJLoader',
	PDBLoader = 'PDBLoader',
	PLYLoader = 'PLYLoader',
	RGBELoader = 'RGBELoader',
	SVGLoader = 'SVGLoader',
	STLLoader = 'STLLoader',
	TTFLoader = 'TTFLoader',
}
